<template>
  <div class="page">

    <slot name="header" v-if="!hideHeader">
      <!-- Allow for custom header styles by overriding the "header" slot -->
      <header class="border-bottom" v-if="isNativeApp === false">
        <b-row class="mx-0">
          <b-col>
            <header-campaigns v-if="isCampaignsEnabled"/>
            <header-im v-else-if="isNewHeader"/>
            <header-mentorship v-else-if="$root.isOnlyMentorship"/>
            <header-block v-else/>
          </b-col>
        </b-row>
      </header>
    </slot>

    <b-container v-if="err">
      <b-row class="mt-2">
        <b-col cols="12" style="min-height: 80%"/>
      </b-row>
    </b-container>

    <template v-else-if="loading">
      <loading-spinner class="full-screen"/>
    </template>

    <template v-else>
      <b-row v-if="statuses.length">
        <b-col class="mx-2">
          <status-bar v-for="(status, i) in statuses" :key="i" class="my-1" :status="status"/>
        </b-col>
      </b-row>

      <!-- Allow for custom layout styles -->
      <b-row class="my-3 mx-0">
        <b-col :class="layoutClass">
          <slot><empty-slot/></slot>
        </b-col>
      </b-row>

      <slot name="footer" v-if="!hideFooter">
        <!-- Allow for custom footer styles by overriding the "footer" slot -->
        <footer class="nav-footer">
          <b-row class="mx-0">
            <b-col>
              <footer-block/>
            </b-col>
          </b-row>
        </footer>
      </slot>
    </template>
    <no-ssr v-if="company && company.siteBranding">
      <cookie-law theme="base" v-if="!isNativeApp && !company.siteBranding.disableCookieWarning">
        <b-container fluid slot-scope="props" style="max-width: 1600px; margin: 0 auto;">
          <b-row>
            <b-col style="display: flex; justify-content: center; align-items: center;"><p>{{ $t('variables.cookie-message') }}</p></b-col>
            <b-col style="display: flex; justify-content: center; align-items: center;"><b-button variant="primary" @click="props.accept"><span>{{ $t('variables.cookie-button') }}</span></b-button></b-col>
          </b-row>
          <b-row v-if="company.siteBranding.customFooterHTML" class="custom-footer-html" v-html="company.siteBranding.customFooterHTML"/>
        </b-container>
      </cookie-law>
    </no-ssr>
  </div>
</template>

<script>
import HeaderBlock from '@/components/Header';
import HeaderIm from '@/components/HeaderIM';
import HeaderCampaigns from '@/components/HeaderCampaigns';
import HeaderMentorship from '@/components/HeaderMentorship';
import HeaderMinimalBlock from '@/components/Header-minimal';
import LoadingSpinner from '@/components/misc/LoadingSpinner';
import FooterBlock from '@/components/Footer-minimal';
import CookieLaw from 'vue-cookie-law';
import { getStatusesForRoute } from '@/lib/status';
import { mapRoot, mapPreferences } from '@/mixins/root';
import { StatusBar } from '@src/components/Statuses';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    err: {
      type: [ Object, String, Error ],
    },
    layoutClass: { // @deprecated
      type: String,
      default: null,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    HeaderBlock,
    HeaderIm,
    HeaderCampaigns,
    HeaderMentorship,
    HeaderMinimalBlock,
    LoadingSpinner,
    FooterBlock,
    CookieLaw,
    StatusBar,
  },
  mounted() {
    if (this.err) {
      this.$notifyFatalErr(this.err);
    }
  },
  computed: {
    ...mapRoot([ 'company', 'isNativeApp', 'isOnlyMentorship' ]),
    ...mapPreferences([ 'isNewHeader', 'isCampaignsEnabled' ]),
    statuses() {
      return getStatusesForRoute(this.$route).filter(status => status && status.type === 'bar');
    },
  },
  watch: {
    err(err) {
      if (err) {
        this.$notifyFatalErr(err);
      }
    },
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap-grid";

.page {
  position: relative;
  width: 100%;

  margin: 0 auto 0 auto;
  max-width: 1600px;

  @include media-breakpoint-only(xs) {
    header > .container-fluid > .row > .col {
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page.vue